import React, { useRef } from 'react';
import { Icon } from 'tea-component';
import { useIntl } from 'umi';
import fileDefault from "@/pages/aigc/assets/svg/file_default.svg";
import useIsTextOverflow from '@gp/components/EllipsisHover/_hooks/useIsTextOverflow';
import CommonBubble from '@home/components/CommonBubble';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';


interface FileItemProps {
  file: {
    id: string;
    name: string;
    status: 'success' | 'uploading' | 'error' | 'pending';
    type: string;
    /** 体积（byte）；缺省或 0 时只展示类型、不展示大小 */
    size?: number;
    hover?: boolean;
    metadata: {
      name: string;
    };
  };
}

const FileItem: React.FC<FileItemProps> = ({ file }) => {
  const { formatMessage } = useIntl();

  const renderFileStatus = () => {
    const { status, type, size } = file;
    const formatValue = size < 1000 
      ? `${size}B`
      : dataFormat({ value: size || 0, formatRule: 'db_int_bmk00' });
    if (status === 'success') {
      return (
        <>
          <span className="dba-file-type">{type}</span>
          {typeof size === 'number' && size > 0 ? (
            <span className="dba-file-size">{formatValue}</span>
          ) : null}
        </>
      );
    }

    if (status === 'uploading'|| status === 'pending') {
      return (
        <>
          <Icon
            size="l"
            type="loading"
            className="dba-file-loading"
          />
          <span className="dba-file-size">
            {formatMessage({ id: 'dba_uploading' })}
          </span>
        </>
      );
    }

    if (status === 'error') {
      return (
        <>
          <span className="dba-file-type">
            <Icon
              size="l"
              type="error"
              className="dba-file-loading"
            />
            {formatMessage({ id: 'dba_upload_error' })}
          </span>
        </>
      );
    }

    return null;
  };

  // const handleOpen = () => {
  //   file?.status === 'success' && file?.fileSrc && window.open(file?.fileSrc);
  // };
  const wrapper = useRef<HTMLDivElement | null>(null);
  const isOverflow = useIsTextOverflow(wrapper, { text: file.name });
  const fileName = file?.metadata?.name || file?.name || '-';
  return (
    <div className="dba-file-item">
      <div className="dba-file-icon">
        <img src={fileDefault} alt={fileName} />
      </div>
      <div className="dba-file-details">
        <div className="dba-file-name"> 
          {file?.status !== 'error' && <div className={'dbg-ellipsis-hover'}>
            <CommonBubble
              dark
              arrowPointAtCenter
              overlayClassName="dbg-bubble-max-width dbg-ellipsis-hover__text-bubble dba-nav-menu-overlay"
              content={!isOverflow ? undefined : fileName}
            >
              <div ref={wrapper} className="dbg-ellipsis-hover__text-wrapper">
                <span className="dbg-ellipsis-hover__text-content">{fileName}</span>
              </div>
            </CommonBubble>
          </div>
          }
          {file?.status === 'error' && fileName}
        </div>
        <div className="dba-file-meta">{renderFileStatus()}</div>
      </div>
    </div>
  );
};

export default FileItem;
